'use client';

import { ReactNode } from 'react';
import { ClientInit } from './client-init';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <>
      <ClientInit />
      {children}
    </>
  );
}
